var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('o-loading',{ref:"loading"}),_vm._v(" "),_c('transition',{attrs:{"mode":"out-in","name":"page"}},[(_vm.layout)?_c(_vm.layout,{tag:"component"}):_vm._e()],1),_vm._v(" "),_c('notifications',{attrs:{"classes":"ortic-notifications"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }